import React, { useMemo } from 'react';
import './Leaderboard.css';

const Leaderboard = ({ balances }) => {
  // Удаляем дубликаты и сортируем балансы по убыванию
  const sortedBalances = useMemo(() => {
    // Фильтруем только валидные записи с адресом и балансом
    const validBalances = balances.filter(item => 
      item && 
      item.address && 
      typeof item.address === 'string' && 
      item.balance !== undefined && 
      item.balance !== null &&
      !isNaN(parseFloat(item.balance))
    );
    
    // Удаляем дубликаты по адресу, оставляя запись с наибольшим балансом
    const uniqueBalances = validBalances.reduce((acc, current) => {
      const existing = acc.find(item => item.address === current.address);
      if (!existing) {
        acc.push(current);
      } else {
        // Если найден дубликат, оставляем запись с большим балансом
        if (parseFloat(current.balance) > parseFloat(existing.balance)) {
          const index = acc.indexOf(existing);
          acc[index] = current;
        }
      }
      return acc;
    }, []);
    
    // Сортируем по убыванию баланса
    const sorted = uniqueBalances.sort((a, b) => parseFloat(b.balance) - parseFloat(a.balance));
    
    // Логирование для отладки (можно убрать в продакшене)
    console.log('Original balances:', balances.length);
    console.log('Valid balances:', validBalances.length);
    console.log('Unique balances:', uniqueBalances.length);
    console.log('Final sorted balances:', sorted.length);
    
    return sorted;
  }, [balances]);

  // Функция для получения эмодзи призового места
  const getPrizeEmoji = (position) => {
    switch (position) {
      case 1: return '🥇';
      case 2: return '🥈';
      case 3: return '🥉';
      case 4: return '🏅';
      case 5: return '🎖️';
      default: return '';
    }
  };

  // Функция для получения CSS класса призового места
  const getPrizeClass = (position) => {
    if (position <= 5) {
      return `prize-${position}`;
    }
    return '';
  };

  // Function to format balance with dollar sign
  const formatBalance = (balance) => {
    const num = parseFloat(balance);
    if (num >= 1000000) {
      return '$' + (num / 1000000).toFixed(2) + 'M';
    } else if (num >= 1000) {
      return '$' + (num / 1000).toFixed(2) + 'K';
    }
    return '$' + num.toFixed(4);
  };

  // Function to format 24h change percentage
  const formatChange24h = (change24h) => {
    if (change24h === undefined || change24h === null) {
      return '-';
    }
    const num = parseFloat(change24h);
    const sign = num >= 0 ? '+' : '';
    const className = num > 0 ? 'change-positive' : num < 0 ? 'change-negative' : 'change-neutral';
    
    return (
      <span className={className}>
        {`${sign}${num.toFixed(2)}%`}
      </span>
    );
  };

  // Function to shorten address
  const shortenAddress = (address) => {
    if (!address || address.length < 10) return address;
    return `${address.slice(0, 6)}...${address.slice(-4)}`;
  };

  if (!balances || balances.length === 0) {
    return (
      <div className="no-data">
        <div className="no-data-icon">📊</div>
        <h3>No data to display</h3>
        <p>Balance data has not been loaded yet or is unavailable</p>
      </div>
    );
  }

  return (
    <div className="leaderboard">
      <div className="table-container">
        <table className="leaderboard-table">
          <thead>
            <tr>
              <th>Rank</th>
              <th>Address</th>
              <th className="balance-header">Balance</th>
              <th className="change-header">24h Change</th>
            </tr>
          </thead>
          <tbody>
            {sortedBalances.map((item, index) => {
              const position = index + 1;
              const prizeClass = getPrizeClass(position);
              const prizeEmoji = getPrizeEmoji(position);
              
              return (
                <tr key={`${item.address}-${index}`} className={`leaderboard-row ${prizeClass}`}>
                  <td className="position-cell">
                    {prizeEmoji ? `${prizeEmoji} ${position}` : position}
                  </td>
                  <td className="address-cell">
                    <a 
                      href={`http://hypurrscan.io/address/${item.address}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="address-link"
                      title={item.address}
                    >
                      {shortenAddress(item.address)}
                    </a>
                  </td>
                  <td className="balance-cell">
                    {formatBalance(item.balance)}
                  </td>
                  <td className="change-cell">
                    {formatChange24h(item.change24h)}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Leaderboard;
